export enum WriteOnEdgeOriginTypeEnum {
  USER = "USER",
  SYSTEM = "SYSTEM"
}
